import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const SessionTimeoutModal = ({ show, onContinue, onLogout }) => {
  const [countdown, setCountdown] = useState(120); // 2 minutes in seconds

  useEffect(() => {
    if (show) {
      setCountdown(120);
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            onLogout(); // Auto logout when countdown reaches 0
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [show, onLogout]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Modal 
      show={show} 
      backdrop="static" 
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Header>
        <Modal.Title>Session Warning</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Your session will expire due to inactivity in:</p>
        <div className="text-center">
          <h3 className="text-danger">{formatTime(countdown)}</h3>
        </div>
        <p className="text-muted small mt-3">
          Click "Stay Logged In" to continue your session, or you will be automatically logged out.
        </p>
      </Modal.Body>
      <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'nowrap', gap: '0.5rem' }}>
        <Button variant="secondary" onClick={onLogout}>
          Logout Now
        </Button>
        <Button variant="primary" onClick={onContinue}>
          Stay Logged In
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionTimeoutModal;